import React from 'react';
import {SubHeading, MenuItem} from '../../components';
import {images, data} from '../../constants';
import {motion} from 'framer-motion'

import './SpecialMenu.css';

const SpecialMenu = () => (
    <div className='w-full min-h-screen bg-black flex flex-col sm:flex-col ' id='menu'>

        <div className="width w-[80%] m-auto mt-20">
            <div
                className="title mt-5 text-center text-yellow-200 flex flex-col items-center justify-center ">
                <SubHeading title='Menu that fits your Palatte' className="text-center"/>
                <div className="div mt-6">
                    <h1 className='text-4xl text-yellow-200 font-main'>Today's Special</h1>
                </div>
            </div>
            <div className="menu mt-16 flex flex-col md:flex-row gap-12">
                <motion.div
                    whileInView={{
                        scale: [
                            0, 1
                        ],
                        opacity: [0, 1]
                    }}
                    transition={{
                        duration: 0.8,
                        type: 'spring'
                    }}
                    className="div md:basis-[33.33%] basis-[100%] md:mr-12">
                    <p className='text-4xl text-white mb-6 font-semibold text-center'>Wine & Beer</p>
                    {
                        data
                            .wines
                            .map((wine, index) => (

                                <MenuItem
                                    key={wine.title + index}
                                    title={wine.title}
                                    tags={wine.tags}
                                    price={wine.price}/>

                            ))
                    }

                </motion.div>
                <motion.div
                    whileInView={{
                        scale: [
                            0, 1
                        ],
                        opacity: [0, 1]
                    }}
                    transition={{
                        duration: 0.8,
                        type: 'spring'
                    }}
                    className="div md:basis-[33.33%] basis-[100%] mb:mr-12">
                    <img src={images.menu} alt="" className='w-full'/>
                </motion.div>
                <motion.div
                    whileInView={{
                        x: [
                            100, 0
                        ],
                        opacity: [0, 1]
                    }}
                    transition={{
                        duration: 0.8,
                        type: 'spring'
                    }}
                    className="div md:basis-[33.33%] basis-[100%] md:mr-12">
                    <div className="div">
                        <p className='text-4xl font-semibold text-white mb-6 text-center'>Cocktail</p>
                        {
                            data
                                .cocktails
                                .map((cocktail, index) => (

                                    <MenuItem
                                        key={cocktail.title + index}
                                        title={cocktail.title}
                                        tags={cocktail.tags}
                                        price={cocktail.price}/>

                                ))
                        }
                    </div>
                </motion.div>
            </div>

            <motion.div
                 whileInView={{x:[-100,0], opacity:[0,1]}}
    transition={{duration: 0.8, type: "tween"}}
            
             className="div mt-4 text-center rounded-sm">
                <motion.button
                   
                    type='button'
                    className='button text-black bg-yellow-200 p-2 mb-6'>View More
                </motion.button>
            </motion.div>

        </div>

    </div>
);

export default SpecialMenu;
